<script lang="ts" setup>
import CouponSvg from '@/assets/img/coupon.svg'

const props = withDefaults(defineProps<{
  item?: string
  quantity?: number
  couponCode?: string
  image?: string
  variant?: 'product' | 'prescription'
}>(), {
  variant: 'product',
})
const { t } = useTranslation()
const { goToCart } = useCart()

const imageWrapperClass = computed(() => {
  switch (props.variant) {
    case 'product':
      return 'p-2 rounded w-16.5 h-16.5'
    case 'prescription':
      return 'p-4 rounded-lg w-18 h-18'
    default:
      return ''
  }
})
</script>

<template>
  <div class="ia-block w-full flex gap-4 border-1 border-grey-200 rounded-b-lg bg-success-50 p-4 shadow-black-bottom-lg sm:w-97.75 sm:rounded-lg">
    <slot name="image">
      <div
        flex-center
        :class="[imageWrapperClass]"
        class="m-b-auto shrink-0 bg-white"
      >
        <NuxtImg
          v-if="image"
          class="max-h-full max-w-full"
          :src="image"
          alt="Notification image"
        />
      </div>
    </slot>
    <div
      flex="~ col"
      class="w-full justify-between"
    >
      <slot name="notification">
        <p class="mb-3 text-sm font-400 font-sans text-grey-800">
          <span class="!font-700">{{ quantity }}x {{ item }}</span>
          {{ t('notification.addToCart.addedToCart') }}
        </p>
      </slot>
      <div
        v-if="couponCode"
        flex
        gap-2
      >
        <CouponSvg
          alt="Coupon image"
        />
        <p
          class="text-xs leading-3.5 text-success-500"
          v-html="t('notification.addToCart.couponAdded', { couponCode })"
        >
        </p>
      </div>
      <button
        class="relative w-fit cursor-pointer self-end text-xs font-700 leading-4.5 uppercase text-success-500 underline"
        @click="goToCart()"
      >
        {{ t('keyword.toCart') }}
      </button>
    </div>
  </div>
</template>
